import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface DrawerState {
  openDrawerId: string | null;
}

const initialState: DrawerState = {
  openDrawerId: null,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openDrawer(state, action: PayloadAction<string>) {
      state.openDrawerId = action.payload;
    },
    closeDrawer(state) {
      state.openDrawerId = null;
    },
  },
});

export const { openDrawer, closeDrawer } = drawerSlice.actions;

export const drawerReducer = drawerSlice.reducer;
